<template>
  <div class="bg-green minheight100" style="padding-bottom: 95px" v-if="dataDetail">
    <div class="prelative header-con">
      <img src="./images/deposit_bg.png" />
      <div class="pabsolute dcon flexdiv average">
        <div class="pabsolute" style="top: 40px; left: 40px">累计获取金额（元）：{{ dataDetail.totalAmount }}</div>
        <div class="centerinfo">
          <p>当前可提现金额（元）</p>
          <h3>{{ dataDetail.waitWithdrawalAmount }}</h3>
        </div>
      </div>
    </div>
    <div class="circular">
      <div class="btn-common btn-deposit flexdiv average" :class="{ disabled: !dataDetail.showCashBtn }">
        <div class="block" @click="dataDetail.showCashBtn ? depositClick() : null">
          提 现
          <br />
          <font v-if="dataDetail.btnDisableMsg">
            {{ dataDetail.btnDisableMsg }}
          </font>
        </div>
      </div>
    </div>
    <div
      class="ui-text-center"
      style="font-size: 12px; color: #ecd0a2; margin-bottom: 20px; margin-top: 15px; opacity: 0.6"
    >
      注：每人每天可提现1次，每次最高提现200元
    </div>
    <div class="pt16 activity-title">
      <span class="tl"></span>
      提现记录
      <span class="tr"></span>
    </div>
    <div class="pd16">
      <div class="invite pd12">
        <!-- <div class="title"></div> -->
        <div class="list">
          <ul v-if="dataDetail.outAccountItems && dataDetail.outAccountItems.length">
            <li style="border-bottom: 1px solid #e6e6e6; margin-bottom: 20px; padding-bottom: 5px">
              <div class="con">
                <div class="flexdiv average mb5">
                  <span>提现金额</span>
                  <span>提现时间</span>

                  <span>状态</span>
                </div>
              </div>
            </li>
            <li v-for="(item, index) in dataDetail.outAccountItems" :key="index">
              <div class="con">
                <div class="flexdiv average mb5">
                  <span>
                    <strong>￥{{ item.cashVal }}</strong>
                  </span>
                  <span>
                    {{ item.createTime.substr(5) }}
                  </span>
                  <template>
                    <span v-if="item.status === 1" style="color: #00aa3a">提现成功</span>
                    <span v-else-if="item.status === 0" style="color: #2890ff">提现中</span>
                    <span v-else-if="item.status === 2" style="color: #999">提现失败</span>
                  </template>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="nocon" style="padding: 60px 0">
            <img src="./images/noperson.png" style="margin-top: 0" />
            <p>暂无</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { activityService } from '@/api'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Popup, Dialog } from 'vant'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'

const action = 'activityDeposit'

export default {
  name: '',
  components: {},
  data() {
    return {
      swiperKey: Math.random().toString(36).substr(2) /*随机的key*/,
      title: '提现',
      activityId: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      dataDetail: null,
      wxshow: false,
      notFromIndex: false
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mixins: [Body],
  created() {
    document.title = this.title
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity_progress?activityId=15
    this.activityId = this.$route.query.activityId
    this.shareUserId = appUser.userId
    console.log(appUser.userId)

    if (this.notFromIndex) {
      this.$router.replace({
        path: '/activity',
        query: e.$route.query
      })
    }
    // // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getData()
  },
  activated() {
    this.getData()
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    console.log(to) //当前
    console.log(from)
    next(e => {
      // if (from.name !== 'activity') {
      //   e.$router.replace({
      //     path: '/activity',
      //     query: { activityId: e.activityId }
      //   })
      // }
    })
  },
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    //进度
    getData() {
      if (!this.shareUserId) {
        this.$router.replace({
          path: '/activity',
          query: this.$route.query
        })
      }
      activityService
        .activityCashInfo({
          activityId: this.activityId
        })
        .then(res => {
          this.dataDetail = res
        })
    },
    // // 设置分享数据
    // setShareData() {
    //   const { shareImg, shareMainTitle, shareSecondTitle } = this.dataDetail
    //   if (title) {
    //     return {
    //       title: shareMainTitle,
    //       desc: shareSecondTitle,
    //       link: location.href,
    //       imgUrl: shareImg
    //     }
    //   }
    // },
    //领取奖励
    handleClick() {
      if (this.dataDetail.isObtainReward === true) this.wxshow = true
    },
    //提现
    depositClick() {
      // // 如果没有登录，先去登录
      if (!this.hasUser()) {
        return
      }
      Dialog.confirm({
        message:
          this.dataDetail.waitWithdrawalAmount > 200
            ? '今天最高可提现200元，是否确认提现？'
            : '当前可提现' + this.dataDetail.waitWithdrawalAmount + '元，是否确认提现？',
        confirmButtonColor: '#00B25A'
      })
        .then(() => {
          if (!appUser.openId) {
            Toast('请使用微信浏览器操作！')
            return
          }
          activityService
            .activityWithdrawal({
              activityId: this.activityId,
              openId: appUser.openId,
              preAmount: this.dataDetail.waitWithdrawalAmount > 200 ? 200 : this.dataDetail.waitWithdrawalAmount
            })
            .then(res => {
              this.getData()
            })
        })
        .catch(err => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.my-swiper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 180px;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: visible !important;
  .swiper-wrapper .swiper-slide {
    width: 41.6%;
    border-radius: 8px;
    overflow: hidden;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}

.user {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px 40px;
}
.userinfo {
  margin-left: 20px;
  margin-top: 15%;
  font-size: 14px;
  color: #974f07;
  h3 {
    font-size: 18px;
  }
  p {
    margin-top: 10px;
  }
}

.invite {
  border-radius: 8px;
  background: #366c6d;
  .title {
    color: #ffe4bc;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .list {
    background-color: #fff8ee;
    border-radius: 8px;
    color: #333;
    position: relative;
    padding: 20px;
    li {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        position: absolute;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    .con {
      margin-left: 0px;
      padding: 4px;
      span {
        width: 40%;
        text-align: center;
        &:first-child {
          text-align: left;
          width: 30%;
        }
        &:last-child {
          text-align: right;
          width: 30%;
        }
      }
    }
    p {
      font-size: 12px;
    }
  }
}
.header-con {
  padding: 20px 20px 0;
  color: #974f07;
  .dcon {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .centerinfo {
      margin: auto;
      text-align: center;
      p {
        padding-top: 15px;
      }
      h3 {
        font-size: 40px;
        line-height: 1;
        margin-top: 5px;
      }
    }
  }
}
.circular {
  position: relative;
  z-index: 10;
  background: url('./images/deposit_bottom_bg.png') no-repeat;
  background-size: 100% auto;
  height: 40px;
  margin-top: -25px;
}
.btn-deposit {
  width: 180px;
  padding: 0px;
  height: 46px;
  background: url('./images/deposit_btn.png') no-repeat;
  background-size: 100% 100%;
  font-size: 16px;
  font-weight: bold;
  color: #ffe1b0;
  position: absolute;
  left: 0;
  right: 0;
  top: -10px;
  &.disabled {
    background-image: url('./images/deposit_btn_disabled.png');
    color: #fff;
  }
  font {
    font-size: 12px;
    font-weight: normal;
    display: inline-block;
    line-height: 1;
  }
}
</style>
